import { useTranslation } from 'react-i18next';
import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Button
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import MainNavbar from "../components/Navbars/MainNavbar";
import Footer from "../components/Footer/Footer";
import { useAuth } from "../context/AuthContext";
import PanelContainer from "../components/Layout/PanelContainer";
import PanelContent from "../components/Layout/PanelContent";
import { useProjectList } from "../context/ProjectListContext";

interface PrivateLayoutProps {
  children: React.ReactNode;
  breadcrumbItems?: { label: string; href: string }[]; // Optionnel maintenant, pour compatibilité temporaire
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentUser, userPlan } = useAuth();
  const { projects } = useProjectList();

  const showUpgradeBanner = userPlan === 'free' && projects.length >= 1;

  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
    }
  }, [currentUser, navigate]);

  return (
    <Box minH="100vh" display="flex" flexDirection="column" bgGradient="linear(to-br, gray.900, blue.900)">
      
      {showUpgradeBanner && (
        <Box bgGradient="linear(to-r, orange.400, red.500)" p={2} textAlign="center" position="relative" zIndex={1001}>
            <Text color="white" fontSize="sm" fontWeight="bold" display="inline-block" mr={4}>
                {t("upgradeBannerText") || "Vous avez atteint la limite du plan gratuit (1 projet). Passez à la vitesse supérieure !"}
            </Text>
            <Button 
                size="xs" 
                variant="solid" 
                colorScheme="whiteAlpha" 
                onClick={() => navigate('/subscribe')}
                _hover={{ bg: "white", color: "orange.500" }}
            >
                {t("upgradeNow") || "Passer Pro"}
            </Button>
        </Box>
      )}

      {/* Top Navigation */}
      <MainNavbar />

      {/* Main Content */}
      <Box flex="1" position="relative" overflow="auto">
        <PanelContent>
          <PanelContainer>
            <Flex flexDirection="column" mt="30px">
              {children}
            </Flex>
          </PanelContainer>
        </PanelContent>
        <Footer />
      </Box>
    </Box>
  );
};

export default PrivateLayout;
